export enum DropdownState {
  UPCOMING = "UPCOMING",
  PAST = "PAST",
}
